import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../App";
import DeliveryTable from "./orderTables/DeliveryTable";
import ExchangeTable from "./orderTables/ExchangeTable";
import OrderTable from "./orderTables/OrderTable";
import ProcessingTable from "./orderTables/ProcessingTable";
import CloseIcon from "@mui/icons-material/Close";

function OrdersTable() {
  const product_context = useContext(ProductContext);

  const {
    orderTableCategory,
    soldDataSearchById,
    setIsLoading,
    alert,
    setAlert,
  } = product_context;

  const [productSearch, setProductSearch] = useState("");
  const [orderDetails, setOrderDetails] = useState([]);
  const [changeSellsState, setChangeSellsState] = useState(false);
  const [input, setInput] = useState("");

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_SERVER_DOMAIN}/sell?product_search=${productSearch}`
      )
      .then((res) => {
        setOrderDetails(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: "Something Went Wrong",
          type: "danger",
        });
        setIsLoading(false);
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    // eslint-disable-next-line
  }, [productSearch, changeSellsState]);

  return (
    <div>
      <div className="d-flex flex-wrap align-items-center justify-content-around m-3">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setProductSearch(e.target.search.value);
          }}
          className="d-flex my-3 position-relative"
        >
          <input
            value={input}
            className="form-control search"
            type="search"
            name="search"
            placeholder="Search"
            aria-label="Search"
            onChange={(e) => {
              setInput(e.target.value);
            }}
          />
          {productSearch ? (
            <CloseIcon
              onClick={(e) => {
                setProductSearch("");
                setInput("");
              }}
              className="fa-solid fa-xmark searchCLose"
            ></CloseIcon>
          ) : null}
          <button type="submit" className="btn btn-secondary mx-2">
            Search
          </button>
        </form>
      </div>
      <hr />

      {orderTableCategory === "ordertable" ? (
        <OrderTable
          orderDetails={orderDetails}
          soldDataSearchById={soldDataSearchById}
          setChangeSellsState={setChangeSellsState}
          changeSellsState={changeSellsState}
        />
      ) : null}
      {orderTableCategory === "processingtable" ? (
        <ProcessingTable
          orderDetails={orderDetails}
          setChangeSellsState={setChangeSellsState}
          changeSellsState={changeSellsState}
        />
      ) : null}
      {orderTableCategory === "deliverytable" ? (
        <DeliveryTable
          orderDetails={orderDetails}
          setChangeSellsState={setChangeSellsState}
          changeSellsState={changeSellsState}
        />
      ) : null}
      {orderTableCategory === "exchangetable" ? (
        <ExchangeTable
          orderDetails={orderDetails}
          setChangeSellsState={setChangeSellsState}
          changeSellsState={changeSellsState}
        />
      ) : null}
    </div>
  );
}

export default OrdersTable;
